export const Logout = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M2.66667 14.6673C2.48986 14.6673 2.32029 14.5971 2.19526 14.4721C2.07024 14.347 2 14.1775 2 14.0007V2.00065C2 1.82384 2.07024 1.65427 2.19526 1.52925C2.32029 1.40422 2.48986 1.33398 2.66667 1.33398H13.5001C13.6769 1.33398 13.8465 1.40422 13.9715 1.52925C14.0965 1.65427 14.1667 1.82384 14.1667 2.00065V14.0007C14.1667 14.1775 14.0965 14.347 13.9715 14.4721C13.8465 14.5971 13.6769 14.6673 13.5001 14.6673H2.66667ZM9 12.0007L13 8.00067L9 4.00067V7.00067H4V9.00067H9V12.0007Z'
      fill='inherit'
    />
  </svg>
);
